// src/solutions.js
var Webflow = Webflow || [];
Webflow.push(function() {
    gsap.registerPlugin(ScrollTrigger);
    let mm = gsap.matchMedia();
    mm.add("(max-width: 766px)", () => {
        console.log("Initializing Swiper on Mobile...");

        const featuresSection = document.querySelector('.layout32_item-list')
        const featureComponents = document.querySelectorAll('.layout32_item')
        featureComponents.forEach(component => {
            component.classList.add('swiper-slide');
        })

        let featureSwiper = new Swiper(featuresSection,{
            slidesPerView: 1,
            cssMode: true,
            createElements: true,
            navigation: false,
            pagination: {
                el: featuresSection.parentElement.querySelector(".features_swiper_pagination"),
                clickable: true,
            },
        })

        const gallerySection = document.querySelector('.gallery_wrapper')
        const galleryComponents = document.querySelectorAll('.gallery_component')

        galleryComponents.forEach(component => {
            component.classList.add('swiper-slide');
        })


        let gallerySwiper = new Swiper(gallerySection,{
            slidesPerView: 'auto',
            cssMode: true,
            createElements: true,
            centeredSlides: true,
            pagination: {
                el: gallerySection.parentElement.querySelector(".gallery_swiper_pagination"),
                clickable: true,
            },
        })

        return () => {
            console.log("Destroying Swiper on Mobile...");
            const swiperEl = featureSwiper.el;
            featureSwiper.destroy(true, true);
            const wrapper = swiperEl.querySelector(".swiper-wrapper");
            if (wrapper) {
                const slides = [...wrapper.children];
                swiperEl.append(...slides);
                wrapper.remove();
            }
            swiperEl.classList.remove("swiper-initialized");
            swiperEl.querySelectorAll('.layout32_item').forEach((item) => {
                item.classList.remove('swiper-slide');
            })

            const gallerySwiperEl = gallerySwiper.el;
            gallerySwiper.destroy(true, true);
            const galleryWrapper = gallerySwiperEl.querySelector(".swiper-wrapper");
            if (galleryWrapper) {
                const slides = [...galleryWrapper.children];
                gallerySwiperEl.append(...slides);
                galleryWrapper.remove();
            }
            gallerySwiperEl.classList.remove("swiper-initialized");
            console.log('mobile duplicate wrap', gallerySwiperEl);
            console.log('mobile duplicate', gallerySwiperEl.querySelectorAll('.swiper-slide-duplicated'))
            gallerySwiperEl.querySelectorAll('.swiper-slide-duplicated').forEach((item) => {
                item.remove();
            })
            gallerySwiperEl.querySelectorAll('.gallery_component').forEach((item) => {
                item.classList.remove('swiper-slide');
            })
        };
    });

    mm.add("(min-width: 767px)", () => {
        console.log("Running Desktop Animations...");

        const gallerySection = document.querySelector('.gallery_wrapper')
        const galleryComponents = document.querySelectorAll('.gallery_component')

        galleryComponents.forEach(component => {
            component.classList.add('swiper-slide');
        })

        let gallerySwiper = new Swiper(gallerySection,{
            slidesPerView: 'auto',
            cssMode: true,
            createElements: true,
            rewind: true,
            navigation: {
                nextEl: '.gallery_swiper-button-next',
                prevEl: '.gallery_swiper-button-prev',
            },
        })

        return () => {
            console.log("Destroying Swiper on Desktop...");
            const swiperEl = gallerySwiper.el;
            gallerySwiper.destroy(true, true);
            const wrapper = swiperEl.querySelector(".swiper-wrapper");
            if (wrapper) {
                const slides = [...wrapper.children];
                swiperEl.append(...slides);
                wrapper.remove();
            }
            swiperEl.classList.remove("swiper-initialized");
            console.log('desktop duplicate wrap', swiperEl);

            console.log('desktop duplicate', swiperEl.querySelectorAll('.swiper-slide-duplicated'))

            swiperEl.querySelectorAll('.swiper-slide-duplicated').forEach((item) => {
                item.remove();
            })
            swiperEl.querySelectorAll('.gallery_component').forEach((item) => {
                item.classList.remove('swiper-slide');
            })
        };
    });
});

